import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import './SubscriptionPages.scss';

const PaymentFailPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  useEffect(() => {
    sessionStorage.removeItem('subscriptionPostPaymentRedirect');
    sessionStorage.removeItem('subscriptionPostPaymentSnackbar');
  }, []);

  return (
    <div className="subscription-page">
      <header className="subscription-page__header">
        <button type="button" className="subscription-page__back" onClick={() => navigate('/subscription/tariffs')} aria-label="Back">
          ←
        </button>
        <h1 className="subscription-page__title">{t('subscription.paymentFailTitle')}</h1>
      </header>
      <div className="subscription-empty">
        <p>{t('subscription.paymentFailBody')}</p>
        <button
          type="button"
          className="subscription-btn subscription-btn--primary"
          onClick={() => navigate('/subscription/tariffs')}
        >
          {t('subscription.tryAgain')}
        </button>
      </div>
    </div>
  );
};

export default PaymentFailPage;
